<template>
  <v-card class="elevation-0">
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="affected_pk"
      :loading="loading"
      :options.sync="options"
      :footer-props="{
        'items-per-page-options': datatables_rowsPerPageItems,
      }"
      :server-items-length="totalItems"
      class="elevation-0"
    >
      <template v-slot:loading>
        Loading items..
      </template>

      <template v-slot:[`item.affected_at`]="{ item }">
        {{ datatables_formatTimestamp(item.affected_at) }}
      </template>

      <template v-slot:[`item.affected_old_values`]="{ item }">
        <table class="inner-table">
          <tbody>
            <tr v-for="(value, key) in item.oldValuesObj" :key="key">
              <td>{{key}}</td><td>{{value}}</td>
            </tr>
          </tbody>
        </table>
      </template>

      <template v-slot:[`item.affected_new_values`]="{ item }">
        <table class="inner-table">
          <tbody>
            <tr v-for="(value, key) in item.newValuesObj" :key="key">
              <td>{{key}}</td><td>{{value}}</td>
            </tr>
          </tbody>
        </table>
      </template>

      <template v-slot:[`footer.page-text`]="props">
        {{ datatables_footerPageText(totalItemsIsEstimate, estimatedItems, props) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import dataTablesMixin from '@/mixins/datatables'

export default {
  name: 'DiscountsChangedTable',

  data () {
    return {
      headers: [
        { text: 'Vertical', value: 'vertical' },
        { text: 'Geo', value: 'co_lang' },
        { text: 'Provider', value: 'provider' },
        { text: 'Campaign(s)', value: 'campaign_names_csv' },
        { text: 'Type', value: 'duration_type' },
        { text: 'Valid from', value: 'valid_from_display' },
        { text: 'Valid until', value: 'valid_until_display' },
        { text: 'Value', value: 'value' },
        { text: 'Changed at', value: 'affected_at' },
        { text: 'Changed by', value: 'affected_by' },
        { text: 'From', value: 'affected_old_values' },
        { text: 'To', value: 'affected_new_values' },
      ],
      items: [],
      loading: false,
      totalItems: 0,
      estimatedItems: 0,
      totalItemsIsEstimate: false,
      options: {},
      lsOptions: 'discountsChanged_options',
      dataEndpoint: '/a/core/discounts-data-updates',
    }
  },

  mixins: [dataTablesMixin],

  computed: {
  },

  watch: {
    options: {
      handler () {
        this.fetchData()
      },
      deep: true,
    },
  },

  methods: {
    fetchData: function () {
      let myURL = this.dataEndpoint + '?xfields='
      this.loading = true

      // get fields from headers
      myURL = this.datatables_addHeaderFieldsToURI(myURL, this.headers, [], ['affected_pk', 'id'])

      // get paging and sorting from options via data table component and save to localStorage
      myURL = this.datatables_processURIOptions(myURL, this.options)
      localStorage.setItem(this.lsOptions, JSON.stringify(this.options))

      this.$http.get(myURL).then(resp => {
        if (resp.data.data) {
          this.items = resp.data.data
          this.totalItemsIsEstimate = resp.headers['x-total-count-estimated'] === 'true' ? true : false
          var itemCounts = this.datatables_getItemCounts(this.totalItemsIsEstimate, Number(resp.headers['x-total-count']))
          this.totalItems = itemCounts.totalItems
          this.estimatedItems = itemCounts.estimatedItems

          // convert the old and new JSON diff properties to objects
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].oldValuesObj = JSON.parse(this.items[i].affected_old_values)
            this.items[i].newValuesObj = JSON.parse(this.items[i].affected_new_values)
          }
        } else {
          this.items = []
        }
      })
      .catch(errResp => {
        this.$store.commit('system/setAPIError', { method: 'GET', url: myURL, description: errResp.response.data.err_description, ext_msg: errResp.response.data.external_message })
      })
      .finally(() => this.loading = false)
    },
  },

  created: function () {
    // get data and refresh regularly to prevent stale data from being shown
    this.timer = setInterval(this.fetchData, this.datatables_refreshIntervalMs)

    // if present, use local sorting/paging options
    if (localStorage.getItem(this.lsOptions)) {
      this.options = JSON.parse(localStorage.getItem(this.lsOptions))
      // setting multisort here: in v-data-table didn't work
      this.options['multiSort'] = true
    } else {
      this.options = {'multiSort': true}
    }
  },

  beforeDestroy () {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.inner-table tbody tr td:nth-child(1) {
    min-width: 120px;
}
</style>
